import React from 'react'
import NavBar from '../components/Navbar/NavBar'
import OrderReady from '../components/Orders/OrderReady'

const Deliveries = () => {
  return (
    <div>
       <NavBar/>
       <OrderReady/>
        </div>
  )
}

export default Deliveries